import React, { useState } from "react";
import "../styles/PricingPage.css";
import icon from "../assets/rightArrow.png";
import checkicon from "../assets/check.png";

const PricingPage = () => {
  const [selectedPlan, setSelectedPlan] = useState("Free Plan");
  const [billingCycle, setBillingCycle] = useState("Monthly");

  const plans = [
    {
      name: "Free Plan",
      description: "Get started with our startup package",
      price: "Free",
      features: [
        "Fast Processing",
        "All Styles & Models",
        "Commercial License",
        "Limited Support",
        "Basic Features",
        "No Customization",
        "Community Access",
        "Standard Quality",
        "Limited Models",
      ],
    },
    {
      name: "Standard Plan (Save 60%)",
      description: "Get started with our standard package ",
      price: "$ 20.00",
      features: [
        "Enhanced Processing",
        "Full Styles & Models",
        "Extended Commercial License",
        "Priority Support",
        "Advanced Features",
        "Basic Customization",
        "Premium Community Access",
        "High Quality",
        "Extensive Models",
      ],
    },
    {
      name: "Premium Plan",
      description: "Get started with our premium package",
      price: "$ 39.99",
      features: [
        "Fastest Processing",
        "All Styles & Premium Models",
        "Full Commercial License",
        "Dedicated Support",
        "All Features",
        "Full Customization",
        "Exclusive Community Access",
        "Ultra Quality",
        "All Models",
      ],
    },
  ];

  return (
    <div className="pricing-page">
      <div className="review-header">
        <div className="line-image"></div>
        <h1 className="review-title">Pricing</h1>
        <div className="line-image"></div>
      </div>
      <h2 className="feature-heading">Get Started with us</h2>
      <div className="billing-cycle">
        <div className="cycle-container">
          <button
            className={billingCycle === "Monthly" ? "selected" : ""}
            onClick={() => setBillingCycle("Monthly")}
          >
            Monthly
          </button>
          <button
            className={billingCycle === "Yearly" ? "selected" : ""}
            onClick={() => setBillingCycle("Yearly")}
          >
            Yearly
          </button>
        </div>
      </div>
      <div className="plans">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`plan-box ${
              selectedPlan === plan.name ? "selected" : ""
            }`}
            onClick={() => setSelectedPlan(plan.name)}
          >
            <div className="plan-details">
              <h2>{plan.name}</h2>
              <p>{plan.description}</p>
              <h3 style={{ color: "#7064E9", fontSize: 30 }}>{plan.price}</h3>
            </div>
            <button
              className={`join-button ${
                selectedPlan === plan.name ? "selected" : ""
              }`}
            >
              Join this plan{" "}
              <img src={icon} alt="Icon" className="button-icon" />
            </button>
            <ul
              style={{
                fontFamily: "Inter",
                color: "#7376AA",
                fontSize: 13,
              }}
            >
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <br></br>
                  <br></br>
                  <img src={checkicon} alt="Icon" className="button-icon" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPage;
